export type PortalTab = 'consulta' | 'descarga';

export const TAB_PARAM = 'tab';
export const TAB_CONSULTA: PortalTab = 'consulta';
export const TAB_DESCARGA: PortalTab = 'descarga';

interface TabAvailability {
  showConsulta: boolean;
  showDescarga: boolean;
}

/**
 * Resuelve la tab activa a partir del query param, respetando la visibilidad por permisos.
 * Si el param falta o no está permitido, cae a Consulta (o Descarga si Consulta no está disponible).
 */
export const resolveTab = (raw: string | null, { showConsulta, showDescarga }: TabAvailability): PortalTab => {
  const requested = raw === TAB_DESCARGA || raw === TAB_CONSULTA ? raw : null;

  if (requested === TAB_DESCARGA && showDescarga) return TAB_DESCARGA;
  if (requested === TAB_CONSULTA && showConsulta) return TAB_CONSULTA;

  if (showConsulta) return TAB_CONSULTA;
  if (showDescarga) return TAB_DESCARGA;
  return TAB_CONSULTA;
};
